module.exports = __webpack_public_path__ + "static/media/nav-earth.7a33f6a8.svg";